"use client";

import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
import { blurPlugin } from "@/lib/motion/blur-plugin";

let registered = false;

export function registerGsap() {
  if (registered || typeof window === "undefined") return;
  gsap.registerPlugin(
    useGSAP,
    ScrollTrigger,
    ScrollToPlugin,
    ScrollSmoother,
    SplitText,
    blurPlugin,
  );
  gsap.config({ nullTargetWarn: false });
  registered = true;
}

export {
  gsap,
  useGSAP,
  ScrollTrigger,
  ScrollToPlugin,
  ScrollSmoother,
  SplitText,
};

export const U = 1.25;
export const EASE_IO = "power3.inOut";
export const EASE_OUT = "power3.out";
export const EASE_IN = "power3.in";
